// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const GatewayProviderCategorySchema = z.enum(['CDN','WAF','LOAD_BALANCER','PROXY','UNKNOWN'] as const);

export type GatewayProviderCategoryType = `${z.infer<typeof GatewayProviderCategorySchema>}`

export default GatewayProviderCategorySchema;
